import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import axios from 'axios';

const INIT_STATE = {
    loading: false,
    openModal: false,
    data: null,
    loadingLabels: false,
    offset: 0,
    items: [],
    total: 0,
};

const route = "modules/devices/.components/maintenanceWarnings/redux/slice";

export const maintenanceWarningsSearchLanguageLabels = createAsyncThunk("devices/maintenanceWarnings/searchMaintenanceWarningEvents", async (payload, { rejectWithValue, dispatch }) => {
    try {

        let lang = localStorage.getItem("lan");
        if (!lang) localStorage.setItem("lan", "en");
        lang = lang[0].toUpperCase() + lang.slice(1);

        let url = `https://s3.amazonaws.com/${endpoints.PUBLIC_REPOSITORY_CODE}/languages/languagelabels_${lang}.js`;
        // Get info resellers from S3
        (async () => {
            try {
                const response = await axios.get(url);
                const langKeys = response?.data;
                localStorage.setItem("langByS3", JSON.stringify(langKeys));
            } catch (error) {
                console.error("Error fetching language keys:", error);
            }
        })();

        return true;

    } catch (exc) {
        console.log(exc)
        // ALWAYS RETURN ACTION
        ExceptionManager(exc, route, 'maintenanceWarningsSearchLanguageLabels');
        return rejectWithValue(exc);
    }
})

export const maintenanceWarningsSearchGroupedMaintenanceWarningEvents = createAsyncThunk("devices/maintenanceWarnings/searchGroupedMaintenanceWarningEvents", async (payload, { rejectWithValue, dispatch }) => {
    try {
        const { unitId, resolved = false, openSearch = '', dateRange, offset } = payload
        let response = await clientQuery(`
                query searchGroupedMaintenanceWarningEvents($openSearch: String, $unitId: Int!, $resolved: Boolean!, $dateRange: AWSDateTimeRange!, $limit: Int!, $offset: Int!) {
                    result: searchGroupedMaintenanceWarningEvents(
                    openSearch: $openSearch
                    unitId: $unitId
                    resolved: $resolved
                    dateRange: $dateRange
                    limit: $limit
                    offset: $offset
                    ) {
                    items {
                        warning
                        firstEventDate
                        lastEventDate
                        eventCount
                        nameResolvedby
                        resolvedBy
                        resolvedOn
                    }
                    total
                    }
                }
            `,
            {
                openSearch: openSearch,
                dateRange: dateRange,
                unitId: unitId,
                resolved: resolved,
                limit: 10,
                offset: offset
            },
            endpoints.GRAPHQL_GENERAL
        )

        return response?.result || { items: [], total: 0 }

    } catch (exc) {
        console.log(exc)
        // ALWAYS RETURN ACTION
        ExceptionManager(exc, route, 'maintenanceWarningsSearchGroupedMaintenanceWarningEvents');
        return rejectWithValue(exc);
    }
})


export const maintenanceWarningsRedux = createSlice({
    name: 'devices/maintenanceWarnings',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        },
        openModalMaintenanceWarnings(state, action) {
            state.openModal = true
            state.data = action.payload
        }
    },
    extraReducers: (builder) => {

        //maintenanceWarningsSearchLanguageLabels
        builder.addCase(maintenanceWarningsSearchLanguageLabels.pending, (state, action) => {
            state.loadingLabels = true
        });
        builder.addCase(maintenanceWarningsSearchLanguageLabels.fulfilled, (state, action) => {
            state.loadingLabels = false;
        });
        builder.addCase(maintenanceWarningsSearchLanguageLabels.rejected, (state, action) => {
            state.loadingLabels = false;
        });

        //maintenanceWarningsSearchLanguageLabels
        builder.addCase(maintenanceWarningsSearchGroupedMaintenanceWarningEvents.pending, (state, action) => {
            state.loading = true
        });
        builder.addCase(maintenanceWarningsSearchGroupedMaintenanceWarningEvents.fulfilled, (state, action) => {
           /*  console.log('state.items -->', state.items)
            console.log('action -->', action.payload) */
            state.loading = false;
            state.items = [...state.items, ...action.payload.items]
            state.total = action.payload.total
        });
        builder.addCase(maintenanceWarningsSearchGroupedMaintenanceWarningEvents.rejected, (state, action) => {
            state.loading = false;
        });
    }
})

const { actions, reducer } = maintenanceWarningsRedux;

// Extract and export each action creator by name
export const {
    reset,
    openModalMaintenanceWarnings
} = actions;

export default reducer;
